<script lang="ts">
  import GroupDirectorAuthorization from "@shared/svelte/Components/GroupDirectorAuthorization.svelte";
  import SideMenuLink from "@shared/svelte/Components/Layout/Header/SideMenu/SideMenuLink.svelte";
  import { ArrowTrayDown, Divider, Flex, GearSolid } from "@getprovi/craft";

  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  import type { RetailerUser } from "@shared/types/User";
  import type { SideMenuLink as SideMenuLinkType } from "@shared/types/SideMenuLink";

  export let closeMenu: () => void;

  const user: RetailerUser = <RetailerUser>$CurrentUserStore;
  const canSeeCredentialManagementTab = user?.distributor_credential_management;

  const links: SideMenuLinkType[] = [
    {
      href: "/product_approvals",
      iconName: ArrowTrayDown,
      title: "Product Requests",
      subtitle: "Manage requests in one place",
      shouldShow: user?.limited_ordering,
    },
    {
      href: "/credential_management",
      iconName: GearSolid,
      title: "Distributor Credentials",
      subtitle: "Manage credentials for distributors",
      shouldShow: canSeeCredentialManagementTab,
    },
  ];
</script>

{#if user.limited_ordering || canSeeCredentialManagementTab}
  <GroupDirectorAuthorization>
    <Flex column gap="16" testId="hamburger-menu-list">
      <span
        class="inline-flex gap-4 w-max admin-workspace py-4 px-10 bg-neutral rounded-full text-xs-uppercase"
      >
        ADMIN WORKSPACE
      </span>
      <Flex as="ul" gap="6" column>
        {#each links as link}
          <SideMenuLink {link} {closeMenu} />
        {/each}
      </Flex>
      <Divider />
    </Flex>
  </GroupDirectorAuthorization>
{/if}
